import React, { useEffect, useMemo, useState } from 'react'

import type { DirectLineAttachment } from '../../../models/directLine'
import renderAttachment from '../../Middlewares/attachmentMiddleware'

import Card from '../../AnswerPanel/Card'
import Grid from '../../Display/Grid'

interface GridContainerProps {
  title?: string
  attachments: Array<DirectLineAttachment>
  history?: boolean
  triggerScroll?: () => void
}

const GridContainer = ({
  title,
  attachments,
  history,
  triggerScroll
}: GridContainerProps): JSX.Element => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string | undefined>(
    undefined
  )
  const processedAttachments = useMemo<Array<DirectLineAttachment>>(() => {
    let tempAttachments = [...attachments]
    tempAttachments = tempAttachments.sort(
      (a: any, b: any) => a.content.index - b.content.index
    )

    return tempAttachments
  }, [attachments])

  useEffect(() => {
    triggerScroll?.()
  }, [])

  return (
    <Grid
      title={title}
      history={history}
      qrCodeDataUrl={qrCodeDataUrl}
      setQrCodeDataUrl={setQrCodeDataUrl}
    >
      {processedAttachments.map((attachment, key) => {
        return (
          <Card key={key} className='rf-w-full' shadow={true}>
            {renderAttachment({
              attachment: attachment,
              history: history,
              setQrCodeData: setQrCodeDataUrl
            })}
          </Card>
        )
      })}
    </Grid>
  )
}

export default GridContainer
